module.exports = __webpack_public_path__ + "img/waves.bb6ba731.svg";